import { Component, OnInit } from '@angular/core';

import { EventService } from '../core/services/event.service';

@Component({
    selector: 'app-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: false
})

/**
 * Layout Component
 */
export class LayoutComponent implements OnInit {

  layoutType!: string;

  constructor() { }

  ngOnInit(): void {
    // Initialize layout from DOM attributes (already set by index.html or previous session)
    this.layoutType = document.documentElement.getAttribute('data-layout') || 'vertical';
    
    // Set default attributes if not already set
    if (!document.documentElement.getAttribute('data-layout')) {
      document.documentElement.setAttribute('data-layout', 'vertical');
    }
    if (!document.documentElement.getAttribute('data-theme')) {
      document.documentElement.setAttribute('data-theme', 'default');
    }
    if (!document.documentElement.getAttribute('data-theme-colors')) {
      document.documentElement.setAttribute('data-theme-colors', 'default');
    }
    if (!document.documentElement.getAttribute('data-bs-theme')) {
      document.documentElement.setAttribute('data-bs-theme', 'light');
    }
    if (!document.documentElement.getAttribute('data-layout-width')) {
      document.documentElement.setAttribute('data-layout-width', 'fluid');
    }
    if (!document.documentElement.getAttribute('data-layout-position')) {
      document.documentElement.setAttribute('data-layout-position', 'fixed');
    }
    if (!document.documentElement.getAttribute('data-topbar')) {
      document.documentElement.setAttribute('data-topbar', 'light');
    }
    if (!document.documentElement.getAttribute('data-preloader')) {
      document.documentElement.setAttribute('data-preloader', 'disable');
    }
    if (!document.documentElement.getAttribute('data-sidebar-visibility')) {
      document.documentElement.setAttribute('data-sidebar-visibility', 'show');
    }
    
    // Set sidebar attributes for vertical/twocolumn layouts
    const layout = this.layoutType;
    if (layout === 'vertical' || layout === 'twocolumn') {
      if (!document.documentElement.getAttribute('data-sidebar')) {
        document.documentElement.setAttribute('data-sidebar', 'dark');
      }
      if (!document.documentElement.getAttribute('data-sidebar-size')) {
        document.documentElement.setAttribute('data-sidebar-size', 'lg');
      }
      if (!document.documentElement.getAttribute('data-sidebar-image')) {
        document.documentElement.setAttribute('data-sidebar-image', 'none');
      }
      if (!document.documentElement.getAttribute('data-layout-style')) {
        document.documentElement.setAttribute('data-layout-style', 'default');
      }
    }
  }


  /**
  * Check if the vertical layout is requested
  */
  isVerticalLayoutRequested() {
    return this.layoutType === 'vertical';
  }

  /**
   * Check if the semibox layout is requested
   */
  isSemiboxLayoutRequested() {
    return this.layoutType === 'semibox';
  }

  /**
   * Check if the horizontal layout is requested
   */
  isHorizontalLayoutRequested() {
    return this.layoutType === 'horizontal';
  }

  /**
   * Check if the horizontal layout is requested
   */
  isTwoColumnLayoutRequested() {
    return this.layoutType === 'twocolumn';
  }

}
